import { api } from '@/utils/api';
import { sanitizePathParam } from '@/utils/sanitize';

export default class ForecastRepository {
  async postParameterPastForecast(
    parameterId: string | number,
    dateFrom: string | null = null,
    dateTo: string | null = null,
    simulationId: string | null = null,
  ): Promise<any> {
    const pid = sanitizePathParam(parameterId);
    const url = `forecast/${pid}/past`;

    const response = await api.get(url, {
      params: { dateFrom, dateTo, simulationId },
    });

    return response.data;
  }
}
